// Mock data for ClutchCricket website

export const coachData = {
  name: "KV Siddharth",
  fullName: "Krishnamurthy Venkatesh Siddharth",
  nickname: "Siddharth",
  role: "Professional Cricketer & Coach",
  born: "November 22, 1992",
  age: 33,
  birthplace: "Bengaluru, Karnataka, India",
  battingStyle: "Right-handed",
  bowlingStyle: "Right-arm medium",
  specialty: "Wicket-keeper batsman",
  tagline: "Transform Your Game with Championship-Level Coaching",
  bio: "KV Siddharth is a right-hand middle-order batsman and wicket-keeper who has made a significant mark in Karnataka cricket. Making his first-class debut against Vidarbha in Nagpur during the 2018-19 season, Siddharth showcased tremendous grit and determination when it mattered most. In his breakthrough season, he compiled a crucial 161 against Mumbai and amassed 728 runs, finishing as the leading run-getter for Karnataka in the 2018-19 Ranji Trophy. His consistency continued with 410 runs in the 2021-22 Ranji Trophy, solidifying his reputation as a reliable performer for Karnataka.",
  heroImages: [
    "https://customer-assets.emergentagent.com/job_a6c06736-dac2-483c-ae6c-d55aae707af1/artifacts/xfbkg5ze_hero.jpeg",
    "https://customer-assets.emergentagent.com/job_premium-cricket/artifacts/77cphvve_hero2.jpeg",
    "https://customer-assets.emergentagent.com/job_premium-cricket/artifacts/g9pn9m2h_hero3.jpeg"
  ],
  logo: "https://customer-assets.emergentagent.com/job_clutch-academy-1/artifacts/yticc8vd_clutchcricket-logo.png"
};

export const careerTimeline = [
  {
    year: "2018-19",
    title: "First-Class Debut",
    achievement: "Leading Run-Scorer for Karnataka",
    description: "Made debut against Vidarbha, scored crucial 161 vs Mumbai",
    stats: "728 runs in debut season",
    icon: "trophy"
  },
  {
    year: "2019",
    title: "T20 & List A Debut",
    achievement: "Expanded Format Portfolio",
    description: "Debuted in Syed Mushtaq Ali Trophy (T20) and Vijay Hazare Trophy (List A)",
    stats: "Multi-format player",
    icon: "star"
  },
  {
    year: "2021-22",
    title: "Consistent Performer",
    achievement: "Top Scorer for Karnataka",
    description: "Delivered consistent performances in Ranji Trophy",
    stats: "410 runs in 4 matches",
    icon: "award"
  },
  {
    year: "2023-Present",
    title: "Professional Journey",
    achievement: "Domestic & International Experience",
    description: "Representing Goa in domestic cricket, signed by Slough Cricket Club as overseas player",
    stats: "Continuous growth",
    icon: "target"
  }
];

export const coachingPrograms = [
  {
    id: 1,
    title: "Elite Batting Academy",
    description: "Master batting techniques from a first-class cricketer. Focus on shot selection, footwork, and match temperament.",
    duration: "12 weeks",
    level: "Advanced",
    sessions: "3 sessions/week",
    features: [
      "One-on-one coaching sessions",
      "Video analysis of your technique",
      "Personalized training plans",
      "Match simulation drills"
    ],
    icon: "bat"
  },
  {
    id: 2,
    title: "Wicket-Keeping Masterclass",
    description: "Learn from an experienced wicket-keeper. Develop lightning-fast reflexes and perfect your technique behind the stumps.",
    duration: "8 weeks",
    level: "Intermediate to Advanced",
    sessions: "2 sessions/week",
    features: [
      "Glove work fundamentals",
      "Positioning and footwork",
      "Communication on field",
      "Stumping techniques"
    ],
    icon: "gloves"
  },
  {
    id: 3,
    title: "Junior Cricket Foundation",
    description: "Build a strong cricket foundation for young aspiring cricketers. Ages 8-16. Focus on fundamentals and love for the game.",
    duration: "16 weeks",
    level: "Beginner to Intermediate",
    sessions: "3 sessions/week",
    features: [
      "Age-appropriate training",
      "Basic batting & bowling skills",
      "Fielding techniques",
      "Team building & sportsmanship"
    ],
    icon: "users"
  },
  {
    id: 4,
    title: "Match Preparation & Strategy",
    description: "Mental conditioning and match preparation strategies used at the first-class level. Learn to perform under pressure.",
    duration: "6 weeks",
    level: "All Levels",
    sessions: "2 sessions/week",
    features: [
      "Mental conditioning",
      "Match situation handling",
      "Opposition analysis",
      "Performance psychology"
    ],
    icon: "brain"
  }
];

export const achievements = [
  {
    stat: "728",
    label: "Runs in Debut Season",
    description: "2018-19 Ranji Trophy"
  },
  {
    stat: "161",
    label: "Highest FC Score",
    description: "vs Mumbai"
  },
  {
    stat: "410",
    label: "Runs in 2021-22",
    description: "Top scorer for Karnataka"
  },
  {
    stat: "10+",
    label: "Years Experience",
    description: "Professional cricket"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Arjun Reddy",
    role: "U-19 State Player",
    image: "https://ui-avatars.com/api/?name=Arjun+Reddy&background=FF6B35&color=fff&size=200",
    rating: 5,
    text: "Training under KV Siddharth has been a game-changer for me. His first-class experience and attention to detail have significantly improved my batting technique. I've made it to the state U-19 team thanks to his coaching!"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Club Wicket-keeper",
    image: "https://ui-avatars.com/api/?name=Priya+Sharma&background=FF6B35&color=fff&size=200",
    rating: 5,
    text: "As a wicket-keeper, learning from someone who has kept wickets at the first-class level is invaluable. Siddharth's insights into positioning, reflexes, and reading the game have elevated my performance tremendously."
  },
  {
    id: 3,
    name: "Rahul Kumar",
    role: "Amateur Cricketer",
    image: "https://ui-avatars.com/api/?name=Rahul+Kumar&background=FF6B35&color=fff&size=200",
    rating: 5,
    text: "The personalized attention and professional training methodology at ClutchCricket is unmatched. Siddharth doesn't just teach technique; he teaches you how to think like a professional cricketer."
  },
  {
    id: 4,
    name: "Vikram Patel",
    role: "Parent of Junior Player",
    image: "https://ui-avatars.com/api/?name=Vikram+Patel&background=FF6B35&color=fff&size=200",
    rating: 5,
    text: "My son has been training at ClutchCricket for 6 months now, and the transformation is remarkable. Not just in skills, but also in his confidence and understanding of the game. Highly recommended!"
  }
];

export const facilities = [
  {
    id: 1,
    title: "Professional Nets",
    description: "State-of-the-art practice nets with quality surfaces",
    icon: "facility"
  },
  {
    id: 2,
    title: "Video Analysis Lab",
    description: "High-speed cameras for detailed technique analysis",
    icon: "video"
  },
  {
    id: 3,
    title: "Fitness Zone",
    description: "Dedicated area for cricket-specific fitness training",
    icon: "dumbbell"
  },
  {
    id: 4,
    title: "Match Simulation Arena",
    description: "Full-sized ground for match practice sessions",
    icon: "stadium"
  }
];

export const contactInfo = {
  whatsapp: "+91 98443 83688",
  email: "info@clutchcricket.com",
  address: "Yeshwanthpur Industrial Area, Phase 1, Yeswanthpur, Bengaluru, Karnataka 560022",
  socialMedia: {
    instagram: "https://www.instagram.com/clutch_cricket_",
    facebook: "https://facebook.com/clutchcricket",
    twitter: "https://twitter.com/clutchcricket",
    youtube: "https://youtube.com/clutchcricket"
  }
};

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_premium-cricket/artifacts/zqszn3wl_WhatsApp%20Image%202025-12-15%20at%2017.32.03.jpeg",
    title: "Training Session",
    description: "Professional cricket coaching in action"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_premium-cricket/artifacts/wvhrlee8_WhatsApp%20Image%202025-12-15%20at%2017.32.04.jpeg",
    title: "Coaching Excellence",
    description: "One-on-one batting technique training"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_premium-cricket/artifacts/un50xny7_WhatsApp%20Image%202025-12-15%20at%2017.32.04%20%281%29.jpeg",
    title: "Academy Facilities",
    description: "State-of-the-art training grounds"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_premium-cricket/artifacts/kwpqivao_WhatsApp%20Image%202025-12-15%20at%2017.32.04%20%282%29.jpeg",
    title: "Practice Sessions",
    description: "Group training and match simulations"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_premium-cricket/artifacts/b6gsqb42_WhatsApp%20Image%202025-12-15%20at%2017.32.05%20%282%29.jpeg",
    title: "Success Stories",
    description: "Players achieving their cricket dreams"
  }
];

export const faqData = [
  {
    question: "What age groups do you cater to?",
    answer: "We offer programs for all age groups starting from 8 years old to adults. Our programs are tailored to suit different skill levels and age categories."
  },
  {
    question: "Do you offer trial sessions?",
    answer: "Yes! We offer a complimentary trial session so you can experience our coaching methodology and facilities before enrolling."
  },
  {
    question: "What equipment do I need to bring?",
    answer: "For your first session, just bring comfortable sports clothing. We provide all cricket equipment including bats, balls, and protective gear. As you progress, we'll guide you on personal equipment."
  },
  {
    question: "Can I get personalized one-on-one coaching?",
    answer: "Absolutely! We offer personalized one-on-one sessions with KV Siddharth for serious players looking to take their game to the next level."
  },
  {
    question: "What makes ClutchCricket different?",
    answer: "You're learning directly from a first-class cricketer with extensive experience at the Ranji Trophy level. Our methodology combines professional techniques with personalized attention."
  }
];
